import { createSelector } from 'reselect';

import { coworkingSelector } from '../root';

export const coworkingWorkplaceCountSelector = createSelector(
  coworkingSelector,
  coworking => coworking?.workplaceCount ?? null,
);
